import React, { useEffect } from 'react';
import { Advertorial } from './pages/Advertorial';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq!.callMethod ? window.fbq!.callMethod.apply(window.fbq, arguments) : window.fbq!.queue.push(arguments);
      };
      window.fbq.queue = [];
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script); // safer than inserting before first script
    }
    window.fbq('init', '1487615955629338'); // your Pixel ID
    window.fbq('track', 'PageView');
  }, []);
  return <Advertorial data-id="element-0" />;
}